export default "__VITE_ASSET__Cppov6PX__"